import http from "./http-common";

class NotificationDataService {
  sendPushNotification(data) {
    return http.post("/notification/push", data);
  }
}

export default new NotificationDataService();
